import { Component, OnInit } from '@angular/core';
import { CompaniesService } from './companies.service';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'companies-component',
  template: require('./companies.component.html'),
  styles: [require('./companies.component.scss')]
})
export class CompaniesComponent implements OnInit {
  companies: any[];
  errorMessage: any;
  predicate: string = 'created_at';
  reverse: boolean;
  onlyActive: boolean = true;
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: CompaniesService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getCompanies();
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getCompanies() {
    this.service.getCompanies().subscribe(items => {
      this.companies = items;
      this.sortBy('it.created_at', this.predicate);
    });
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function('it', `return (${getField} || '').toString().toLowerCase();`);
  }

  formatDate(date: any) {
    return moment(date).format('DD/MM/YYYY hh:mm A');
  }

  editCompany(company) {
    CompaniesService.currentCompany = company;
    this.router.navigate(['/editcompany']);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/companies/companies.component.ts